import { useResponsive } from "components/hooks/useResponsive";
import { DesktopHeader } from "./layouts/DesktopHeader";
import { MobileHeader } from "./layouts/MobileHeader";

interface HeaderProps {
  toggleSider: () => void;
  isSiderOpened: boolean;
  isTwoColumnsLayout: boolean;
}

export const Header = ({
  toggleSider,
  isSiderOpened,
  isTwoColumnsLayout,
}: HeaderProps) => {
  const { isTablet } = useResponsive();

  return isTablet ? (
    <DesktopHeader isTwoColumnsLayout={isTwoColumnsLayout} />
  ) : (
    <MobileHeader toggleSider={toggleSider} isSiderOpened={isSiderOpened} />
  );
};
